<template>
  <div class="casino-search-result">
    <casino-tabs v-if="searchResults" class="casino-page-header-item" @sortTypeSelected="sortGames" @filterSelected="filterSelected" :setDefaultTab="1" :section="'filterAndSort'" :pageType="'search'" :itemCount="searchResults && searchResults.gameIds.length" :providers="providers" :themeList="themeList" :filteredItems="filteredItems" :originalPreparedData="originalPreparedData" :selectedFilterNumberDisplay="selectedFilterNumberDisplay"></casino-tabs>
    <casino-grid-view class="search-grid-view" v-if="searchResults" :data="filterGamesInfoDataByGroup(searchResults.gameIds)" :groupData="searchResults" :key="componentKey"></casino-grid-view>
    <section v-if="!searchResults && !searchPhrase && !gamesLoaded" class="before-search-start">
      <div class="header">{{$t('Casino.Search.ForGameOrByProvider')}}</div>
      <div class="body">{{$t('Casino.Search.ResultsWillShowAsYouType')}}</div>
    </section>
    <section v-if="!searchResults && gamesLoaded && searchPhrase.length >= numOfCharsToStartSearch" class="search-no-results">
      <div class="search-header">{{ $t('Casino.Search.NoResultsFound') }}</div>
      <div class="body">
        <div class="suggestions">
          <span>{{ $t('Casino.Search.Suggestions') }}</span>
          <ul>
            <li> - {{ $t('Casino.Search.Suggestions_1') }}</li>
            <li> - {{ $t('Casino.Search.Suggestions_2') }}</li>
            <li> - {{ $t('Casino.Search.Suggestions_3') }}</li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Casino from '@/components/mixins/Casino'
import store from '@/store'
import CasinoGridView from '@/components/igaming/partials/casinoGridView.vue'
import CasinoTabs from '@/components/igaming/partials/casinoTabs.vue'
import config from '@/config'
export default {
  name: 'casinoSearchResult',
  components: {
    CasinoGridView,
    CasinoTabs
  },
  props: [],
  mixins: [
    Casino
  ],
  data () {
    return {
      numOfCharsToStartSearch: config.app.autoconf.CASINO.SEARCH_NUMBER_OF_CHARS_TO_START || 3,
      preparedData: null,
      originalPreparedData: null,
      componentKey: null,
      themeList: false,
      filteredItems: false,
      selectedFilterNumberDisplay: false,
      onNewSearchResultOverwriteOriginalData: true
    }
  },
  computed: {
    searchResults: {
      get () {
        return store.getters['gap/getResults']
      },
      set (value) {
        store.commit('gap/setResults', value)
      }
    },
    searchPhrase () {
      return store.getters['gap/getPhrase']
    },
    gamesLoaded () {
      return store.getters['gap/getGamesLoaded']
    },
    groupSlug () {
      return this.$route.params.slug
    },
    providers () {
      return store.getters['gap/getProviders']
    }
  },
  methods: {
    prepareGameData () {
      this.preparedData = []
      if (this.onNewSearchResultOverwriteOriginalData) {
        this.originalPreparedData = []
      }
      if (this.searchResults && Array.isArray(this.searchResults.gameIds)) {
        this.searchResults.gameIds.forEach(gameId => {
          const gameObj = this.allGames.games.find(g => String(g.id) === String(gameId))
          if (gameObj) {
            this.preparedData.push(gameObj)
            if (this.onNewSearchResultOverwriteOriginalData) this.originalPreparedData.push(gameObj)
          }
        })
        if (this.onNewSearchResultOverwriteOriginalData) {
          this.onNewSearchResultOverwriteOriginalData = false
        }
      }
      this.themeList = this.getThemeListByCasinoPage(this.preparedData)
    }
  },
  mounted () {
    this.componentKey = Math.random()
  },
  watch: {
    searchResults (newVal) {
      if (newVal) {
        this.prepareGameData()
      }
      if (newVal === undefined) {
        this.onNewSearchResultOverwriteOriginalData = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoSearch/casinoSearchResult.vue